import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { Text } from '@paygreen/paygreen-ui';
import { Message } from '../../components';
import dayjs from '../../utils/dayjsHelper';

const ExportDonationsFormMessage = ({ t, endDate }) => {
    // we define maximum end date that will include donations in export (donations older than 14 days)
    const validEndDate = dayjs().subtract(14, 'day').format('DD/MM/YYYY');

    // we detect if at least, end date received or choosed by user in modal is too late and adapt ux message for user
    const isTooLate =
        dayjs(validEndDate, 'DD/MM/YYYY').diff(dayjs(endDate, 'DD/MM/YYYY')) <
        0;
    const messageColor = isTooLate ? 'warning' : 'default';

    return (
        <>
            <Text textSize="sm" marginBottom="xs" marginTop="sm">
                <Trans i18nKey="shopDonations.exports.exportsIntro">
                    You can export
                    <Text htmlTag="strong" colorPallet="theme" textSize="sm">
                        {{
                            registered: t('shopDonations.exports.registered'),
                        }}
                    </Text>
                    done in
                    <Text htmlTag="strong" textSize="sm">
                        {{
                            inProduction: t(
                                'shopDonations.exports.inProduction',
                            ),
                        }}
                    </Text>
                </Trans>
            </Text>

            <Message hasStaticWidth={true} colorStatus={messageColor}>
                <div>
                    <Text
                        textSize="xs"
                        colorPallet="status"
                        colorStatus={messageColor}
                        marginBottom={isTooLate ? 'xs' : 'none'}
                    >
                        <Trans i18nKey="shopDonations.exports.14DaysMessage">
                            only donations
                            <Text
                                htmlTag="strong"
                                colorPallet="status"
                                colorStatus={messageColor}
                                textSize="xs"
                            >
                                {{
                                    more14Days: t(
                                        'shopDonations.exports.more14Days',
                                    ),
                                }}
                            </Text>
                            be included
                        </Trans>
                    </Text>

                    {isTooLate ? (
                        <Text
                            textSize="xs"
                            htmlTag="strong"
                            colorPallet="status"
                            colorStatus="warning"
                        >
                            {t('shopDonations.exports.warning', {
                                limitDate: validEndDate,
                            })}
                        </Text>
                    ) : null}
                </div>
            </Message>
        </>
    );
};

ExportDonationsFormMessage.propTypes = {
    endDate: PropTypes.string.isRequired,
};

export default withTranslation('common')(ExportDonationsFormMessage);
